module.exports = __webpack_public_path__ + "media/luxury-2026/location-kitchen-960-fffb05e6.jpg";